import lzstring from "lz-string";
import _ from 'lodash';
export default {
    data() {
        return {
            referenceEPARange: 346,
            referenceBatterySize: 56,
            carData: this.$dealer.carData,
            modelData: this.$dealer.modelData
        };
    },
    computed: {
        cars() {
            var cars = [];
            for (let i = 0; i < this.carData.length; i++) {
                let car = this.carData[i];
                let model = this.modelData.find(o => o.ID === car.ModelID);
                if (model !== undefined) {
                    let mergedCar = _.merge({}, model, car);
                    mergedCar.ConsumptionRatio = (mergedCar.MaxRange / mergedCar.BatterySize) / (this.referenceEPARange / this.referenceBatterySize);
                    if (mergedCar.Name === undefined || mergedCar.Name === null) {
                        mergedCar.Name = "";
                    }
                    cars.push(mergedCar);
                }
            }
            return cars;
        }
    },
    methods: {
        updateProfile(id) {

            var val = this.$user.driverProfiles.find(obj => {
                return obj.ID == id;
            });
            val.extraWeight = this.driver.extraWeight;
            val.stateOfHealth = this.driver.soh / 100;
            val.maxCharge = this.driver.batteryMax;
            val.minCharge = this.driver.batteryMin;
            val.currentCharge = this.driver.battery / 100;
            val.numberOfPassengers = this.driver.passengers;
            val.speed = this.driver.sa;
            val.drivingStyle = this.driver.aa / 10;

        },
        openSolarForm() {
            window.open("https://solar.appstack.me/index.php/572861?lang=en&G00Q14=" + encodeURI(this.$dealer.default_settings.name));
        },
        logState() {
            var simplifiedTrips = [];
            this.$trips.forEach(trip => {
                var t = JSON.parse(JSON.stringify(trip));
                t.path = null;
                simplifiedTrips.push(t);
            });
            var stateData = {
                settings: this.$dealer.user_settings,
                trips: simplifiedTrips,
                bubble: this.$bubble
            }

            var savedState = lzstring.compressToEncodedURIComponent(JSON.stringify(stateData));
            console.log(savedState);

            return savedState;
        },
        loadState(string) {
            //var string = "N4IgzgpgLlCWB2BzMIBcoAOBDWATAwgBZYBOiCiAyhGGLAPbwqoAMANCAGYkQRGmIaadiAzQS9ADb56YKGgBMAOgDMAVg5ioE6YzABXALYY4jNADYlGkIXqGIAawDqhYUoUdb9gAoQSAWQR9KAhhTX0AI0lYAGNnV1Z3awxI6JjfAKCQtwVrLHh4fSxJfxx4EPh8mIgASXwAUUUWZo58wuLShAqqiHqANTQARkGWkAAlAFV8MRIAFVt9MHzcIetcWBoIXTkhq0GOdc3dJiMTBnghgE4lcw8QGNJZgE8xZgBtUARcCAAPMNFxFIZCdjKYLqgVAcNpBjgZQec0CoAL5sT7wb5-VD7AHaIF6U5gtAAFisUKOwLhZzMqBJahRaIxik0gNhBIRqEsa2hWwpbOpnPpIC+v0RzNxrPh1JGZJhvMl4JGSIAuiiQNpYBh3p8VliOHAoJJQqgQABxWAANwgAAIoIRYGAbSQNVasFbKvYQBxuBAAI76CDwGJPNDWb1+gNBibwWDyY0Ad14Dk9IHNsCwAEFcLgeLQhKg3kqvRJDJnszRmKBSzmKyBBHZxMH0Pd6PQSOtKiF3oMAOwkgAcI2a3chAFoiYN3IMiWpu+Y+4W1S8jSBvPQuiBVVAl2gQAAxCBYKD6HjJjASGZwPOgWSGAD6eBDtxYlwUPb7dxvt63Yh3ADlkzE9D6OUJCNiAv4QHGVoAFoHpIyzJp+DgQGBGDwdUyYLJAhSGBEfg7moKgATGYFOFs0RIFAZgcHIPDQDuAASWBxtoKFWrMfgkFgGFQrRsSxiARDHlR8BWt4pBJhwn7msU-o7lhoSaLIUCAd8O7mCwKjdsm37LgpG4cFW5YESoVpMSxPBPOxnHcdaQkkCJYkSVaZGSBRiAiRum70EZtBoJWWbVv5tYQPW2iNqAgGtu2h55m8PYkt2fYqESzREmwI4qJYfa9lphELrpO6ruum7bsa+6HseimiOefiXjWn4PqgajTmoLUpd2IifoVxr-hwgHAeFf6QTBcEIVJYB3shqHodVCk4XhJA7oMChEf1JE7oAMoAkIAgIDIbAya0bwAljBAhj+lxVpjPQWArLx6oxCdZ0XVgiGTbeMmSHJxr6UpciqcuIyrTpZU2EBkAGSAvnMCAK2mad51+K6123Vdz1I1a217RAB1Iqq2C2mghRufdPQWCozTNO4gpNUDeoxoaO5mpaNp2g66oYC6bpYB6Ra+v6gaNqGPDhoLUYxjuCaOMmqYZoF5ZxQu3B2NDwWq02db2ENTZRW2CCxV2vZKElKVpRlWVKDlRJ5SoBWg8V5SQz1e4HkeJ6aLVDnQsFjU6i1bXtUSnUTXezt9c2g2gcNUGwcU40gEhKE7mhtmYeDAZGIty3A+tW5bbt+2Hax9HGgjL1XTdd0gOsfGPTuZdI29d6fd9YOLNVGDKQDy0sDni4-j96eQ+rsOrWjiOXSjuDj+XWOF3jeo+fLflNuroCaw2wW6zFnZoPFRsDpTw4ZeOk7TrO856vba6O6VA8u5V7s1fQF7e02vuPgoz6vklH7vWHAEgIgTAhBGOY10RN1vNNZOs007twWvhY0hFiJ52NK5dynkaLFwEuZViVkOIkC4jxau9oHoCXso5cSJBJIJ3ei3PSQ8-oqXoGpY0GktIg3vvpVUI9CJmWYng6yhDbJWgoYwJy1CXLkQoJ5BeohDwJGJpIUmgYjTmAppTamC4IiRCiEaUAkh6APEJKvZeNYR6-liA4AA5A6foVpKC2AwMmDe2tIotj1h2OKPZzDm0uCqORDhDDMApv1YgZAIDpigFQpMqBtD+g4O3Eg3geCcERCIJYqYkBgH8Cw5cER6CEy9P6SQzx76+HFF5IAA";
            var stateData = JSON.parse(lzstring.decompressFromEncodedURIComponent(string))
            console.log(stateData);
            this.$trips.push(...stateData.trips)
            this.$bubble = stateData.bubble
            this.$dealer.user_settings = stateData.settings
            for (let i = 0; i < this.$trips.length; i++) {
                this.$trips[i].path = [];
            }
            this.$router.push("recommender/0")
        },
        getCostForDistance(car, kms, homeCharging, frequency, settings) {
            let kWh = kms / (car.Range / car.BatterySize);
            let runningCosts = 0;
            if (car.Hybrid == true) {
                let evkms = Math.min(car.Range, kms);
                let petrolkms = kms - car.Range;

                let evkWh = evkms / (car.Range / car.BatterySize);
                if (homeCharging) {
                    runningCosts += (evkWh * frequency) * settings.homekWh;
                } else {
                    runningCosts += ((evkWh * frequency) * settings.publickWh) + ((evkWh * frequency) / car.MaxDC) * 60 * settings.publicPerMinute;
                }
                if (petrolkms > 0) {
                    runningCosts += ((petrolkms * frequency) / settings.petrolConsumption) * settings.petrolCost;
                }
                return runningCosts;
            }


            if (homeCharging) {
                let maxCharge = car.BatterySize * car.SoH * 0.85
                if (kWh < maxCharge) {
                    runningCosts += (kWh * frequency) * settings.homekWh;
                } else {
                    runningCosts += (maxCharge * frequency) * settings.homekWh;
                    let topUp = kWh - maxCharge;
                    runningCosts += ((topUp * frequency) * settings.publickWh) + ((topUp * frequency) / car.MaxDC) * 60 * settings.publicPerMinute;
                }
            } else {
                runningCosts += ((kWh * frequency) * settings.publickWh) + ((kWh * frequency) / car.MaxDC) * 60 * settings.publicPerMinute;
            }

            return runningCosts;
        },
        calculateChargingStops(car, bubble, settings, trips = [], useTrips = true) {
            if (car.Hybrid == true) {
                return 0;
            }
            if (trips.length > 0 && useTrips) {
                useTrips = false;
                for (let trip of trips) {
                    if (trip.path.length > 0) {
                        useTrips = true;
                        break;
                    }
                }
            }

            if (trips.length > 0 && useTrips) {
                let chargeCount = 0
                for (let trip of trips) {
                    if (trip.distance) {
                        let kms = trip.distance / 1000;
                        let kWh = kms / (car.Range / car.BatterySize);
                        chargeCount += Math.max(Math.ceil((kWh / (car.BatterySize * car.SoH * 0.8)) - 1), 0) * this.annualFrequency(trip);
                    }
                }
                return chargeCount;

            } else {
                return (Math.max(Math.ceil((bubble.kms / 7 * (1 / car.Consumption)) / (car.BatterySize * car.SoH * 0.8)) - 1, 0)) * 365;
            }
        },

        getTripCost(car, trip, bubble, homeCharging, settings) {
            let kms = trip.distance / 1000;
            if (isNaN(kms)) {
                return this.getCostForDistance(car, bubble.kms / 7, homeCharging, 365, settings);
            }
            let frequency = this.annualFrequency(trip);
            return this.getCostForDistance(car, kms, homeCharging, frequency, settings);

        },
        annualFrequency(trip) {
            let frequency = trip.frequency;
            switch (trip.frequencyUnit) {
                case "day":
                    frequency *= 365;
                    break;
                case "workday":
                    frequency *= 262;
                    break;
                case "week":
                    frequency *= 52;
                    break;
                case "fortnight":
                    frequency *= 26;
                    break;
                case "month":
                    frequency *= 12;
                    break;
            }
            return frequency;
        },
        getTotalKms(trips) {
            let distance = 0;
            for (let trip of trips) {
                if (trip.distance) {

                    let kms = trip.distance / 1000;
                    let frequency = trip.frequency;
                    switch (trip.frequencyUnit) {
                        case "day":
                            frequency *= 365;
                            break;
                        case "workday":
                            frequency *= 262;
                            break;
                        case "week":
                            frequency *= 52;
                            break;
                        case "fortnight":
                            frequency *= 26;
                            break;
                        case "month":
                            frequency *= 12;
                            break;
                    }
                    distance += kms * frequency;
                }
            }
            return distance;
        },
        calculateRunningCosts(car, bubble, settings, trips = [], useTrips = true) {
            if (trips.length > 0 && useTrips) {
                useTrips = false;
                for (let trip of trips) {
                    if (trip.path.length > 0) {
                        useTrips = true;
                        break;
                    }
                }
                if (!useTrips) {
                    return 0;
                }
            }
            if (trips.length > 0 && useTrips) {

                let runningCosts = settings.annualMaintenanceEV;
                for (let trip of trips) {
                    if (trip.path.length > 0) {

                        runningCosts += this.getTripCost(car, trip, bubble, bubble.chargeAtPark, settings);
                    }
                }
                return runningCosts;

            } else {
                let runningCosts = settings.annualMaintenanceEV;
                runningCosts += this.getCostForDistance(car, bubble.kms / 7, bubble.chargeAtPark, 365, settings);
                return runningCosts;
            }

        },
        calculatePetrolCosts(bubble, settings, trips = [], useTrips = true) {
            let runningCosts = settings.annualMaintenanceICE;
            if (trips.length > 0 && useTrips) {
                useTrips = false;
                for (let trip of trips) {
                    if (trip.path.length > 0) {
                        useTrips = true;
                        break;
                    }
                }
            }
            if (trips.length > 0 && useTrips) {
                runningCosts += (this.getTotalKms(trips) / settings.petrolConsumption) * settings.petrolCost;
            } else {
                runningCosts += ((bubble.kms / 7 * 365) / settings.petrolConsumption) * settings.petrolCost;
            }
            return runningCosts;
        },
        calculateChargeCost(car, charger, settings) {
            let kWh = car.BatterySize * 0.7;
            let cost = (kWh * settings.publickWh);
            if (charger.Current == "DC") {
                cost += ((kWh / Math.min(car.MaxDC, charger.KwRated)) * 60) * settings.publicPerMinute;
            }
            return cost;
        },
        calculateChargeTime(car, charger) {
            let kWh = car.BatterySize * 0.7;
            let totalMinutes = 0;
            if (charger.Current == "DC") {
                totalMinutes = (kWh / Math.min(car.MaxDC, charger.KwRated)) * 60;
            } else {
                totalMinutes = (kWh / Math.min(car.MaxAC, charger.KwRated)) * 60;
            }
            let hours = Math.floor(totalMinutes / 60);
            let minutes = Math.floor(totalMinutes % 60);
            let ret = "";
            if (hours > 0) {
                ret += hours + " hours";
                if (minutes > 0) {
                    ret += " and ";
                }
            }
            if (minutes > 0) {
                ret += minutes + " minutes";
            }
            return ret;
        },

        calculateCO2Savings(car, bubble, settings, trips = [], useTrips = true) {
            let co2 = 0;
            if (trips.length > 0 && useTrips) {
                useTrips = false;
                for (let trip of trips) {
                    if (trip.path.length > 0) {
                        useTrips = true;
                        break;
                    }
                }
                if (!useTrips) {
                    return 0;
                }
            }
            if (trips.length > 0 && useTrips) {
                let kms = this.getTotalKms(trips);

                co2 += (kms / settings.petrolConsumption) * 2.3035;
                if (car.Hybrid == true) {
                    let evkms = Math.min(car.Range, kms);
                    let tripCount = 0;
                    for (let trip of trips) {
                        tripCount += this.annualFrequency(trip);
                    }
                    evkms *= tripCount;
                    let petrolkms = kms - evkms;
                    co2 -= this.CO2FromElectricty(car, evkms)
                    co2 -= (petrolkms / settings.petrolConsumption) * 2.3035;
                } else {
                    co2 -= this.CO2FromElectricty(car, kms)
                }
            } else {
                let kms = (bubble.kms / 7 * 365)

                co2 += (kms / settings.petrolConsumption) * 2.3035;
                if (car.Hybrid == true) {
                    let evkms = Math.min(car.Range, bubble.kms / 7) * 365;
                    let petrolkms = kms - evkms;
                    co2 -= this.CO2FromElectricty(car, evkms)
                    co2 -= (petrolkms / settings.petrolConsumption) * 2.3035;
                } else {
                    co2 -= this.CO2FromElectricty(car, kms)
                }
            }
            return Math.floor(co2);
        },
        CO2FromElectricty(car, kms) {
            let kwh = this.kwhForkms(car, kms);
            return kwh * 0.027;
        },
        kwhForkms(car, kms) {
            return kms / (car.Range / car.BatterySize);
        },
        formatPrice(price) {
            //let p = Math.round((price + Number.EPSILON) * 100) / 100
            let p = Math.round(price);
            return parseFloat(p).toLocaleString("en");
        }
    }
}